import { fromApi, isDateOnly } from '../../kit/time';

// The value an <input type="date"> takes: the stored day (UTC for a date-only value).
export const toInputDate = (iso) => {
  if (!iso) return '';
  const d = fromApi(iso);
  if (Number.isNaN(d.getTime())) return '';
  if (isDateOnly(d)) return d.toISOString().slice(0, 10);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// A typed year passes through 0002, 0020, 0202 on its way to 2026; only a plausible year saves.
export const plausible = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v) && +v.slice(0, 4) >= 1900 && +v.slice(0, 4) <= 2100;
